export const ALL_CALENDAR_COUNTRIES = [
  'BE',
  'FR',
  'NL',
  'LU',
  'UG',
  'AE',
  'AF',
  'AD',
  'AL',
  'AM',
  'AO',
  'AR',
  'AT',
  'AU',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BN',
  'BO',
  'BR',
  'BS',
  'BT',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EN',
  'ER',
  'ET',
  'ES',
  'FI',
  'FJ',
  'FM',
  'GA',
  'GB',
  'GD',
  'GE',
  'GH',
  'GM',
  'GN',
  'GQ',
  'GR',
  'GT',
  'GW',
  'GY',
  'HK',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KO',
  'KP',
  'KR',
  'KW',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MR',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NE',
  'NG',
  'NI',
  'NO',
  'NP',
  'NR',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PG',
  'PH',
  'PK',
  'PL',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SI',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SY',
  'SZ',
  'TD',
  'TG',
  'TH',
  'TJ',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VN',
  'VU',
  'WS',
  'YE',
  'ZA',
  'ZM',
  'ZW',
];

export const ALL_COUNTRIES_CODES = [
  'BE',
  'FR',
  'NL',
  'LU',
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AN',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BU',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CS',
  'CT',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DD',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DY',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'HV',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'JT',
  'KE',
  'KG',
  'KH',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MI',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NH',
  'NI',
  'NL',
  'NO',
  'NP',
  'NQ',
  'NR',
  'NT',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PC',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PU',
  'PW',
  'PY',
  'PZ',
  'QA',
  'RE',
  'RH',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SF',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SU',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TP',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VD',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WK',
  'WS',
  'XX',
  'YD',
  'YE',
  'YT',
  'YU',
  'ZA',
  'ZM',
  'ZR',
  'ZW',
];

export const ALL_COUNTRIES_ISO2_TO_ISO3 = {
  AF: 'AFG',
  AX: 'ALA',
  AL: 'ALB',
  DZ: 'DZA',
  AS: 'ASM',
  AD: 'AND',
  AO: 'AGO',
  AI: 'AIA',
  AQ: 'ATA',
  AG: 'ATG',
  AR: 'ARG',
  AM: 'ARM',
  AW: 'ABW',
  AU: 'AUS',
  AT: 'AUT',
  AZ: 'AZE',
  BS: 'BHS',
  BH: 'BHR',
  BD: 'BGD',
  BB: 'BRB',
  BY: 'BLR',
  BE: 'BEL',
  BZ: 'BLZ',
  BJ: 'BEN',
  BM: 'BMU',
  BT: 'BTN',
  BO: 'BOL',
  BA: 'BIH',
  BW: 'BWA',
  BV: 'BVT',
  BR: 'BRA',
  VG: 'VGB',
  IO: 'IOT',
  BN: 'BRN',
  BG: 'BGR',
  BF: 'BFA',
  BI: 'BDI',
  KH: 'KHM',
  CM: 'CMR',
  CA: 'CAN',
  CV: 'CPV',
  KY: 'CYM',
  CF: 'CAF',
  TD: 'TCD',
  CL: 'CHL',
  CN: 'CHN',
  HK: 'HKG',
  MO: 'MAC',
  CX: 'CXR',
  CC: 'CCK',
  CO: 'COL',
  KM: 'COM',
  CG: 'COG',
  CD: 'COD',
  CK: 'COK',
  CR: 'CRI',
  CI: 'CIV',
  HR: 'HRV',
  CU: 'CUB',
  CY: 'CYP',
  CZ: 'CZE',
  DK: 'DNK',
  DJ: 'DJI',
  DM: 'DMA',
  DO: 'DOM',
  EC: 'ECU',
  EG: 'EGY',
  SV: 'SLV',
  GQ: 'GNQ',
  ER: 'ERI',
  EE: 'EST',
  ET: 'ETH',
  FK: 'FLK',
  FO: 'FRO',
  FJ: 'FJI',
  FI: 'FIN',
  FR: 'FRA',
  GF: 'GUF',
  PF: 'PYF',
  TF: 'ATF',
  GA: 'GAB',
  GM: 'GMB',
  GE: 'GEO',
  DE: 'GER',
  GH: 'GHA',
  GI: 'GIB',
  GR: 'GRC',
  GL: 'GRL',
  GD: 'GRD',
  GP: 'GLP',
  GU: 'GUM',
  GT: 'GTM',
  GG: 'GGY',
  GN: 'GIN',
  GW: 'GNB',
  GY: 'GUY',
  HT: 'HTI',
  HM: 'HMD',
  VA: 'VAT',
  HN: 'HND',
  HU: 'HUN',
  IS: 'ISL',
  IN: 'IND',
  ID: 'IDN',
  IR: 'IRN',
  IQ: 'IRQ',
  IE: 'IRL',
  IM: 'IMN',
  IL: 'ISR',
  IT: 'ITA',
  JM: 'JAM',
  JP: 'JPN',
  JE: 'JEY',
  JO: 'JOR',
  KZ: 'KAZ',
  KE: 'KEN',
  KI: 'KIR',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KG: 'KGZ',
  LA: 'LAO',
  LV: 'LVA',
  LB: 'LBN',
  LS: 'LSO',
  LR: 'LBR',
  LY: 'LBY',
  LI: 'LIE',
  LT: 'LTU',
  LU: 'LUX',
  MK: 'MKD',
  MG: 'MDG',
  MW: 'MWI',
  MY: 'MYS',
  MV: 'MDV',
  ML: 'MLI',
  MT: 'MLT',
  MH: 'MHL',
  MQ: 'MTQ',
  MR: 'MRT',
  MU: 'MUS',
  YT: 'MYT',
  MX: 'MEX',
  FM: 'FSM',
  MD: 'MDA',
  MC: 'MCO',
  MN: 'MNG',
  ME: 'MNE',
  MS: 'MSR',
  MA: 'MAR',
  MZ: 'MOZ',
  MM: 'MMR',
  NA: 'NAM',
  NR: 'NRU',
  NP: 'NPL',
  NL: 'NLD',
  NC: 'NCL',
  NZ: 'NZL',
  NI: 'NIC',
  NE: 'NER',
  NG: 'NGA',
  NU: 'NIU',
  NF: 'NFK',
  MP: 'MNP',
  NO: 'NOR',
  OM: 'OMN',
  PK: 'PAK',
  PW: 'PLW',
  PS: 'PSE',
  PA: 'PAN',
  PG: 'PNG',
  PY: 'PRY',
  PE: 'PER',
  PH: 'PHL',
  PN: 'PCN',
  PL: 'POL',
  PT: 'PRT',
  PR: 'PRI',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RU: 'RUS',
  RW: 'RWA',
  BL: 'BLM',
  SH: 'SHN',
  KN: 'KNA',
  LC: 'LCA',
  MF: 'MAF',
  SX: 'SXM',
  PM: 'SPM',
  VC: 'VCT',
  WS: 'WSM',
  SM: 'SMR',
  ST: 'STP',
  SA: 'SAU',
  SN: 'SEN',
  RS: 'SRB',
  SC: 'SYC',
  SL: 'SLE',
  SG: 'SGP',
  SK: 'SVK',
  SI: 'SVN',
  SB: 'SLB',
  SO: 'SOM',
  ZA: 'ZAF',
  GS: 'SGS',
  SS: 'SSD',
  ES: 'ESP',
  LK: 'LKA',
  SD: 'SDN',
  SR: 'SUR',
  SJ: 'SJM',
  SZ: 'SWZ',
  SE: 'SWE',
  CH: 'CHE',
  SY: 'SYR',
  TW: 'TWN',
  TJ: 'TJK',
  TZ: 'TZA',
  TH: 'THA',
  TL: 'TLS',
  TG: 'TGO',
  TK: 'TKL',
  TO: 'TON',
  TT: 'TTO',
  TN: 'TUN',
  TR: 'TUR',
  TM: 'TKM',
  TC: 'TCA',
  TV: 'TUV',
  UG: 'UGA',
  UA: 'UKR',
  AE: 'ARE',
  GB: 'GBR',
  US: 'USA',
  UM: 'UMI',
  UY: 'URY',
  UZ: 'UZB',
  VU: 'VUT',
  VE: 'VEN',
  VN: 'VNM',
  VI: 'VIR',
  WF: 'WLF',
  EH: 'ESH',
  YE: 'YEM',
  ZM: 'ZMB',
  ZW: 'ZWE',
};

export const BELGIUM_PROVINCES = [
  {
    code: 'BXL',
    postal_prefix: [10, 11, 12],
    title: 'Bruxelles / Brussels',
    region: 'BE-BXL',
    url_alias: 'region-bruxelles-brussels',
  },
  {
    code: 'VAN',
    postal_prefix: [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
    title: 'Provincie Antwerpen',
    region: 'BE-VL',
    url_alias: 'provincie-antwerpen',
  },
  {
    code: 'VLI',
    postal_prefix: [35, 36, 37, 38, 39],
    title: 'Provincie Limbug',
    region: 'BE-VL',
    url_alias: 'provincie-limburg',
  },
  {
    code: 'VOV',
    postal_prefix: [90, 91, 92, 93, 94, 95, 96, 97, 98, 99],
    title: 'Provincie Oost-Vlaanderen',
    region: 'BE-VL',
    url_alias: 'provincie-oost-vlaanderen',
  },
  {
    code: 'VBR',
    postal_prefix: [15, 16, 17, 18, 19, 30, 31, 32, 33, 34],
    title: 'Provincie Vlaams-Brabant',
    region: 'BE-VL',
    url_alias: 'provincie-vlaams-brabant',
  },
  {
    code: 'VWV',
    postal_prefix: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
    title: 'Provincie West-Vlaanderen',
    region: 'BE-VL',
    url_alias: 'provincie-west-vlaanderen',
  },
  {
    code: 'WBR',
    postal_prefix: [13, 14],
    title: 'Province du Brabant wallon',
    region: 'BE-WA',
    url_alias: 'province-brabant-wallon',
  },
  {
    code: 'WHT',
    postal_prefix: [60, 61, 62, 63, 64, 65, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
    title: 'Province de Hainaut',
    region: 'BE-WA',
    url_alias: 'province-hainaut',
  },
  {
    code: 'WLG',
    postal_prefix: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
    title: 'Province de Liège',
    region: 'BE-WA',
    url_alias: 'province-liege',
  },
  {
    code: 'WLX',
    postal_prefix: [66, 67, 68, 69],
    title: 'Province de Luxembourg',
    region: 'BE-WA',
    url_alias: 'province-luxembourg',
  },
  {
    code: 'WNA',
    postal_prefix: [50, 51, 52, 53, 54, 55, 56],
    title: 'Province de Namur',
    region: 'BE-WA',
    url_alias: 'province-namur',
  },
];

export const BELGIUM_REGIONS = [
  {
    code: 'BE-WA',
    title: 'Wallonie',
    url_alias: 'wallonie',
    path: 'M339.9,165.5c0.1-2-2.1-3.9-2.9-5.7c-0.7-1.7,0.1-3.2,0.5-4.9c0.2-1.1,0.5-2.2,0.4-3.3c0-1.5-0.4-1.1-1.2-2.1,c-1.4-1.7-1.5-4-0.1-5.5c-1.7-0.1-3.4-0.4-5-0.9c-0.9-0.3-1.6-0.8-2.4-0.7c-1.3,0.1-2.7,1.4-4,0.8c-0.7-0.3-1.1-1.3-1.3-1.9,c-0.5-1.1-0.8-0.6,0-1.9c-0.4,0.1-1.4,0.1-1.7-0.3c-0.5-0.8,0.6-1.1,0.5-1.6c-0.2-1.9-2-1-0.6-3.1c1.4-2.2,4-3.4,5.5-5.1,c0.5-0.6,1.9-2.1,1.5-2.9c-0.4-0.9-2.9-0.5-3.9-0.5c-1.3,0-2.5,0.1-3.5-0.7c-0.5-0.4-1.2-1-1.2-1.7c-0.1-0.8,0-0.7,0.9-1.2,c-1.5-2.2-2.9-4.4-4.4-6.7c-1.1-1.6-2.1-3.4-4.3-3.2c-1.1,0.1-2.3,0.9-3.4,0.8c-1.4-0.1-1.2-0.7-1.2-1.9c0-0.5,0.2-0.9,0.1-1.4,c-0.2-1-0.5-0.4-1-1.2c-0.3-0.5-0.9-0.5-0.4-1.3c-2.5,0.6-6.7,1.1-9-0.1c0.4,0.5,1.6,1.5,1.6,2.1c0,0.5-1.6,2.6-1.9,2.9,c-1.1,0.8-1.1,0.1-2.3-0.3c-1.1-0.4-1.8,0.1-3,0c-1.1-0.1-0.8,0.1-1.6-0.9c-0.8-0.9-1.5-2.6-2.4-3.3c-1.5-1.1-3,0.9-4.2-1.6,c-0.4,1.4-3.1,0.8-3.6-0.2c-0.6-1,1.2-2.9,0.8-4.2c-0.2-0.8-0.5-0.7-1.4-1c-0.6-0.2-1.5-1-2-1c-1.1-0.1-2.8,2.5-3.8,3.4,c-1.1,0.9-2,1.1-3.4,1.5c-0.9,0.3-4.3,0.7-4.8,1.5c-0.3,0.5,0.4,1.6,0.2,2.2c-0.2,0.5-1.5,1.4-1.9,1.6c-1.8,1.2-2.2,0.4-3.5-1.1,c-0.5,1.9-0.6,2.9-2.8,2.6c-2.9-0.5-1.6-2-3.3-3.6c-1.1-1-3.7,0.2-4.8,0.8c-1.5,0.8-2.1,1.6-2.5,3.2c-0.6-0.3-2.1-1.6-2.7-1.6,c-0.8,0-2.2,1.4-2.8,1.8c-0.2-0.5-0.5-1.1-0.7-1.6c-0.7,1.5-0.6,1.3-2.2,1.1c-1.2-0.1-2.4-0.3-3.6-0.4c0.5,1,1.8,3-0.2,3.6,c-1.3,0.4-3.9-1.5-5.3-1.6c-1.4-0.2-2.6,0.6-3.9-0.3c-1.6-1.1-1.2-2.2-1.6-3.7c-0.3-1.2-1.5-1.5-2.6-2.3c-0.6-0.5-1.7-1.7-2.4-1.9,c-0.8-0.2-0.2-0.2-1.1,0.3c-1.4,0.7-2.5,2.7-4.1,2.8c-2.2,0.1-1.6-1.8-1.4-3.3c-2.2,0.2-4.4,0.5-6.6,0.7c0.1-0.5,0.3-1,0.4-1.5,c-1.6-0.2-1.9,0-2.7-1.3c-0.9-1.4-0.9-1.8-2.3-2.4c-1.2-0.5-2.1-0.8-3.3-0.6c-1.7,0.3-1.8,0.9-2.3,2.4c-0.1-0.4-0.3-0.7-0.4-1.1,c-1.2,0.7-1.2,0.8-2.5,0.6c-1.2-0.2-2.3-0.6-3.5-0.9c-0.1,1-0.6,2.6-0.4,3.5c0.2,0.6,1,1,1.2,1.6c0.3,1,0.3,0.3-0.3,1.3,c-0.6,1-2.2,1.9-3.5,1.3c-0.9-0.4-0.8-1.8-1-3c-1,1.1-1.5,2-2.9,2.5c-2.2,0.7-2.8-0.1-3.1,2.3c-2.1-1.2-3.4-1.3-2.8-3.8,c-3.3-0.9-4.9,2.7-7.9,3.1c-0.6,0.1-2.1,0-2.5,0.4c-0.5,0.4-0.1,1.8-0.6,2.1c-1.4,1-2.8-1.7-3.3-2.4c-1,0.7-0.2,1.4,0.3,2.1,c-0.4,0-1.6-0.2-1.9,0c-0.4,0.3,0.1,1.6-0.2,2.1c-0.9,1.7-2.3,0.7-3.6,0.5c-1.2-0.1-0.6,0.1-1.8,0.6c-1.1,0.4-0.2,0.5-1.3,0,c-0.8-0.4-1.3-1.5-2.1-1.8c-0.6-0.2-1.4,0.2-2,0c-1.2-0.3-1.3-2-2.4-2.6c-1.9-1.1-1.4,1-2.4,1.5c-0.6,0.3-1.5-0.3-2,0.1,c-0.8,0.6-0.2,1-1.1,1.1c-0.6,0.1-1.4-0.8-1.9-0.5c-0.4,0.2-0.9,1.8-1.1,2.2c-0.4-1.4-1-0.5-1.9-0.2c-1.3,0.4-1-0.2-2.3-0.1,c-0.7,0-1.2,1-1.9,1.3c-0.5,0.2-1.1,0.1-1.6,0c-2.9-0.1-7.3,0-7.1-4.2c0.1-1,1.1-3.7-0.4-4.4c-1.3-0.5-3.6,1.5-4.9,1,c-0.6-0.2-0.8-0.9-1.5-1c-0.7-0.1-2.4,0.7-3,0.3c-0.7-0.4-1.2-3.4-1.5-4.3c-0.9,0.4-2.3,1.3-3.2,1.3c-1.1,0.1-0.9-0.5-1.5-1.6,c-1.8,1-2.4,1.2-3.3,3c-0.9,1.8-1.8,3.5-2.7,5.3c-0.7-0.5-1.6-1.4-2.5-1.7c-1.1-0.3-2.8,0-3.9-0.1c-1.1,0-1.5,0.2-1.9-0.5,c-0.5-0.8-0.3-2.8-0.4-3.8c-1.8,0.5-2.9,1.1-4.6,0.5c-2.3-0.8-2-0.9-4,0.6c-2,1.5-5.9,4.1-6.1,6.7c-0.9-0.3-1.4-0.5-2.2-1,c-1.5-0.9-1-0.8-1.2-2.3c-0.1-0.9-0.7-1.9-1.4-2.5c-0.9-0.8-0.8-0.6-2.3-0.4c-1,0.2-1.5,0.3-2.4,0c-0.9-0.3-2-1.6-3-1.6,c-1.5-0.1-3.4,1.9-5,2.3c0.8,1.5,1.3,3.1,2.1,4.5c0.9,1.5,2.2,0.8,3.3,1.8c0.8,0.8,1.7,3.4,1.5,4.4c-0.1,0.8-1,1.4-1.1,2.2,c-0.1,0.8,0.4,2.1,0.5,2.9c0.6,3,2.1,5.9,2.5,8.8c0.5,3.5-0.3,6.2,3.2,8.4c3.1,2,5.5,2.8,9,1.6c1.8-0.7,2.6-1.4,4.1-2.5,c1-0.8,3.1-1.3,3.8,0.1c0.8,1.5-1.9,2.8,0.3,3.6c1.5,0.6,3.8-0.1,5.4,0.1c3.2,0.3,5.8,2.2,7,5.3c1.3,3.4,0.8,7.6,0.9,11.1,c0.1,1.8,0.1,3.8,0.6,5.5c0.5,1.6,2,2.5,3.2,3.7c0.1-1.1,0.6-0.6,0.9-1.1c0.4-0.6,0.5-1.2,0.8-1.9c0.7-1.4,1.7-3.3,3.4-3.7,c1.8-0.5,4-0.2,5.8,0c2.1,0.2,3.1,1.2,4.8,2.2c3.8,2.1,6.3-1.6,10-1.8c1.9-0.1,2.9,1,4,2.4c1.3,1.5,3,2.1,4.4,3.6,c1.4,1.4,1.7,3.4,2.7,5c0.4,0.6,0.6,1.4,1.6,1.4c1.3,0,0.5-0.7,0.9-1.5c0.3-0.7,0.3-1.2,1.3-1.1c0.8,0.1,1.7,0.9,2.3,1.4,c1.7,1.6,1,2.9-0.6,4.3c-1.4,1.2-2.5,2.1-2.9,4c-0.5,2-0.9,3.9-1.6,5.9c-0.4,1.3-1.5,4,0.3,4.5c1.4,0.3,2.7-1.9,3.8-0.1,c1.2,1.7,0.9,4.7,1.8,6.7c0.3,0.7,1,1.3,0.5,2.1c-0.3,0.5-2.2,1.2-2.8,1.6c-1.7,1.1-3.2,2.4-3.9,4.3c-0.5,1.6,0.5,3.6,0.6,5.6,c-0.2,0-0.5,0-0.7-0.1c2.3,1.3,4.4,3.1,7.1,2.8c2.1-0.2,4.2-1,6.3-0.7c3.3,0.5,6.6,1.8,9.8,2.7c2.1,0.6,3.6,1.1,5.8,0.4,c2.6-0.9,5.2-2.6,7.7-3.8c1.3-0.6,2.6-1.5,4-2c1-0.4,2.1-0.4,3.2-0.7c2.3-0.6,2.8-2.5,3.2-4.7c0.2-1.2,0.6-2.9,0.5-4.1,c-0.1-1.2-0.6-1.9-0.4-3.2c0.5-2.6,3.7-4.7,5.4-6.4c2.2-2.3,3.9-4.2,6.7-5.6c0.3,1.5,0.2,2.4,1.8,2.4c1.4,0,2.5-1.2,3.1,0.7,c0.6,2-0.5,5.4-0.7,7.4c-1.6-1.6-1.6-0.6-2.4,1.1c-0.7,1.5-0.7,2.4-0.7,4c0,3.1-2.2,6.1-3.1,9c-0.3,1.1-0.8,2.2-0.4,3.2,c0.7,1.9,2.4,2,4,2.8c2.7,1.4,2.8,4.1,1.9,6.8c-0.2,0.6-0.3,1.2-0.6,1.8c-0.2,0.5-0.8,1.1-1,1.6c-0.5,1.5,0.8,2.3,1.1,3.7,c0.6,2.9-1.4,6.4,2.9,6.4c2.5,0,5-2.2,7.5-1.7c2.7,0.5,4.1,4,6.7,5c1.5,0.6,2.8,0.5,3.9,1.7c1,1.1,1.8,2.5,2.6,3.7,c1.5,2.2,3.5,4.8,6.3,4.7c1.3,0,2.6-0.9,3.9-1c1.8-0.2,2.5,0.7,3.6,1.9c0.7,0.7,2.5,2.8,2.1,4c-0.2,0.5-0.9,0.6-1.1,1,c-0.2,0.5-0.2,1.4-0.2,1.9c0.2,1.6,1.6,2.4,2.9,1.3c0.4-0.3,0.4-1.2,0.9-1.4c0.5-0.2,1.4,0.6,1.9,0.8c3.3,1.3,4,2.6,5.7,5.7,c0.8,1.4,1.7,2.8,2.3,4.2c0.6,1.5,0.2,2.4,0.1,3.9c-0.1,1.4,0.1,2.7,1.8,2.7c1.4,0,2.7-1.2,3.8-2c1.8-1.4,2.6-1.6,4.6-0.7,c0.7,0.3,1.4,0.7,2.2,0.5c1-0.2,0.7-0.5,1.1-1.3c0.6-1.3,1.8-2.7,3.4-2.8c1.6-0.1,3,1.3,4.6,1.5c2.1,0.2,1.8-1,3.4-1.9,c1.8-1,2.5,1,4.2,1.1c1.6,0.1,3.2-1.5,4-2.7c0.4-0.5,1-1.4,1-2c0-0.7-0.4-0.7-1.2-1.2c1.4-1.3,1.7-2.8,2.4-4.5,c0.6-1.2,2.2-2.2,2.3-3.5c0.1-0.4-0.2-1.7-0.5-2.1c-0.7-0.7-1.5-0.2-2.2-0.6c-1.3-0.7-0.9-2.3-0.5-3.5c0.3-0.8,1.5-2.7,0.2-3.4,c-0.3-0.2-1.4,0-1.9-0.1c-0.5-0.1-1.8-0.5-2-0.9c-0.4-0.6-0.3-2.7-0.8-3.7c-0.6-1.4-1.2-3.3-2.5-4.2c-0.7-0.5-1.7-0.5-2.4-1,c-0.6-0.5-0.9-1.4-1.2-2.2c-0.6-1.7-0.9-3.8,0.9-4.7c-1.4-0.9,0-1.6-0.4-2.8c0.8,0.1,1.5,0.2,2.3,0.3c-0.6-0.9-0.9-1.3-1.8-2,c-1.1-0.9-2.1-0.8-1.7-2.3c0.5-1.9,2.2-3.6,3-5.4c0.4-0.7,0.5-1.6,0.9-2.3c0.7-1.2,1.4-1,2.4-1.6c0.7-0.4,1.4-1.2,1.6-2.1,c0.2-1-0.4-1.2-0.7-2.1c-0.7-2.8,2.3-2.3,3-4.2c0.3-0.8,0-1.8,0.1-2.6c0.1-1.4,0.3-1.5,1.3-2.5c1.5-1.6,0.7-3.5,1.8-5.2,c1.1-1.7,3.5-1.9,4.9-3.2c1.8-1.5,1.1-3.9,2.4-5.4c0.7-0.9,1.3-0.5,2.3-0.9c1.4-0.6,1.2-1.4,1.9,0.3c0.5,1,0.4,1.6,1.6,2.1,c0.8,0.4,2,0.3,2.9,0c0.7-0.2,1.4-1.2,2-1.2c0.9,0,1.6,1.2,1.8,2.1c0.2,0.8-0.3,2,0.3,2.6c0.9,1,1.9,0.2,2.1-0.9,c0.2-1.1-0.8-1.4-0.9-2.3c-0.1-0.6,0.3-1.9,0.7-2.4c0.7-0.7,1.8-0.1,2.6-0.7c0.7-0.6,0.9-1.8,0.9-2.7c-0.1-1-0.5-1.5-0.9-2.3,c-0.5-1.1-1-1,0.2-2.1c1.6-1.5,3.1-2.9,5.3-3.6c1.1-0.4,2.3-0.5,3.3-1.1c1.6-1,1-1.2,1-2.7c0-1.1,0.7-2.5,1.4-3.3,c1-1,1.7-0.8,3-0.5C336.6,168.1,340.9,168.1,339.9,165.5z',
  },
  {
    code: 'BE-VL',
    title: 'Vlaanderen',
    url_alias: 'vlaanderen',
    path: 'M286,80.1c0.6-1,1.5-1.6,0.2-2.2c-0.7-0.3-2,0.3-2.7,0.5c1.4-2.3,4.1-5.4,4.5-8.2c0.2-1.1,0.1-0.4-0.3-1.5,c-0.4-1-0.6-0.7-0.5-1.9c0.1-1.8,0.7-2.8,2.2-1.4c1.6-1.9,1.7-3.5,1.3-5.8c1.4,0.2,2.5-0.1,3.6-0.9c-1-1.1-2.2-1.6-1.8-3.1,c0.4-1.5,1.5-1.2,0.9-2.9c-1-3.2-4,0.3-5.9-1.6c-2-2.1-2.4-4-5.7-3.3c-1.1,0.2-2.6,0.9-3.7,0.5c-1-0.3-1.6-1.5-2.5-2.1,c-2.1-1.5-5.3-1-7-3.2c-1.3-1.7-0.5-4.6-1.6-6.6c-1.2-2.2-3.6-3.8-6.1-2.9c-2.2,0.9-3.8,3.3-6.3,3.7c-2.8,0.5-6.2-0.3-9.1-0.4,c-1.4,0-5.1,1.6-6,0.4c-0.6-0.7,0.2-3.4,0-4.3c-0.2-0.9-0.8-2.1-1.7-2.5c-2.3-1.2-5.1,1.5-6.6-1.3c-0.6-1-0.6-2.4-1.1-3.5,c-0.6-1.4-1.7-2.3-2.6-3.5c-1.6-1.9-1.6-3.8-0.7-6.1c1-2.6,1.2-4.7-0.8-7c-0.5-0.5-2-1.7-2.7-1.8c-1.5-0.4-1.9,0.9-2.3,2.1,c-0.8,2.5-2.3,4.9-4,6.9c-0.9,1-1.9,2-3.1,2.3c-1.6,0.4-2.7-0.7-4.3-1.2c-2.6-0.9-5.5-0.1-8.1-0.8c-0.8-0.2-1.3-0.4-1.4-1.1,c-0.2-1,0.5-1.3,1.3-1.4c1-0.1,3,1.3,3.9,1.8c-0.6-2.5-0.1-3.7,0.2-6.2c0.2-2.2-0.5-3.6-2.5-4.6c-4.5-2.3-7.4,2.8-9.8,5.8,c-1.1,1.3-2.2,3.3-3.7,4.1c-2,0.9-3.7-0.3-5.6-0.2c-1.8,0.1-5.3,0.9-4.6-2.2c0.3-1.5,1.9-4.4-0.2-5.4c-1.8-0.8-5.1,0.9-6.7,1.5,c-2.1,0.8-3.9,2-5.9,3.2c1,1.2,0.9,1.3,0.5,2.8c-0.4,1.3-0.5,2,0.2,3.1c1.1,1.7,3.7,3.9,2.1,6.2c-1.2,1.7-5.1,0.8-6.7,0.2,c-1.2-0.4-2.2-1.3-3.4-1.7c-0.9-0.3-1.9-0.2-2.8-0.3c1,1.2,1.9,2.3,2.2,3.9c0.2,1.3-0.5,3.1,0.2,4.3c0.6,1.1,3.3,1.2,3.6,2.1,c0.4,1.2-1.9,3.6-2.9,3.9c2.1-3.1,0-4.6-2.1-6.8c-2.1-2.2-1.6-5.5-4.4-7.2c0.4,8.1-7.8,12.8-14,15.9c-1.8,0.9-3.8,1.7-5.5,2.8,c-1.4,0.9-2.6,2.3-4.1,3.1c-1.4,0.7-2.9,0.6-4.4,0.6c-2.4,0-5,0.4-7.3,0.1c-4.4-0.6-1.6-5.2-4-7.2c-1.3-1.1-3.2-1.4-4.8-1.9,c-2.1-0.7-4.3-1.6-6.5-2.1c-1.4-0.4-3.1-0.7-4.5-0.6c-1.1,0.1-2.1,0.6-3.2,0.7c-0.8,0.1-1.8,0-2.5,0.4c-2,1-1.1,2.7-1.2,4.4,c-0.1,2-2.7,1.9-4.4,1.9c-4.4,0.1-7.9-2.9-8.6-7.2c-0.3-1.9,0.3-4,0.4-6c0.1-2-0.4-4.1-0.7-6.1c-5.6,1.8-11.1,3.6-16.7,5.4,c-4.4,1.4-7.9,4.3-11.8,6.8c-8.7,5.7-17.9,10.5-26.6,16.3c-4,2.7-7.6,6.7-11.9,8.9c-1,0.5-2.3,0.6-3.3,1.2c-2,1.1-1.5,1.4-0.8,3.3,c0.9,2.3,0.8,4.8,1.4,7.1c0.7,2.8,2.3,4,4,6.2c1.6,2.1,2.4,4.2,0.5,6.2c-0.7,0.8-1.8,1.5-1.9,2.6c-0.1,1.3,1,3.4,1.3,4.7,c0.3,1.1,0.4,1.6,0,2.8c-0.6,2-0.4,1.4,0.9,2.8c0.9,1,0.7,2.3,2,3c1.3,0.7,2.5,0,3.8,0.1c1.7,0.2,1.7,1.1,2.4,2.4,c0.7,1.2,1.7,2,2.7,3c2,1.9,2.3,4.7,4.3,6.4c2.1,1.8,5.2,2.7,7.7,3.9c-0.7-2.4-4.1-7.8,0.1-8.4c1.3-0.2,2.6,1.8,4.3,0.4,c0.5-0.4,0.4-1.1,1-1.5c0.7-0.5,2-0.8,2.8-1.1c-0.6-0.7-2.1-1.8-1.6-2.7c0.3-0.5,4-1.9,4.6-1.9c2.6-0.2,2.2,3.9,2.6,5.8,c2.7-0.9,6.4-3.1,9.2-1.5c1.3,0.7,1.8,3.5,2.9,3.9c1,0.4,3.5-1.8,4.4-2c1.6-0.4,2.3,1.2,3.9,1.5c1.2,0.3,3-0.8,4-0.4,c0.4,0.2,1.3,1.7,1.5,2.2c0.2,0.6-0.1,1.5,0.1,2.1c0.6,1.4,2.3,1.5,3.5,2c0.1-1.5,2-2.8,3-3.8c1.1-1.1,2.1-2,3.4-2.9,c2.1-1.5,1.6-1.1,4-0.4c1.6,0.5,2.8-0.2,4.4-0.6c0.1,1,0,2.7,0.5,3.6c0.5,0.9,0.6,0.7,1.9,0.7c1.1,0,2.7-0.3,3.7,0.1,c0.9,0.3,1.8,1.1,2.6,1.7c0.9-1.8,1.8-3.5,2.7-5.3c0.9-1.7,1.5-2,3.3-3c0.6,1.2,0.4,1.6,1.5,1.6c1,0,2.3-1,3.2-1.3,c0.3,1,0.8,3.8,1.6,4.3c0.7,0.4,2.3-0.5,3-0.3c0.7,0.1,0.8,0.8,1.4,1c1.3,0.5,3.7-1.5,5-1c0.3,0.1,0.9,1.8,0.9,2.3,c0.1,0.7-0.4,1.4-0.5,2.1c-0.2,3.9,3.6,4.1,6.5,4.2c0.6,0,1.5,0.2,2.1,0c0.7-0.2,1.1-1.3,1.9-1.3c1.2-0.1,1.1,0.5,2.2,0,c0.8-0.3,1.4-1.2,1.8,0.2c0.2-0.5,0.7-2,1.1-2.2c0.5-0.3,1.3,0.6,1.9,0.5c1-0.1,0.2-0.4,1.1-1.1c0.5-0.4,1.3,0.1,1.8-0.1,c1-0.4,0.8-2.3,2.4-1.6c1.2,0.5,1.3,2.3,2.6,2.7c0.6,0.2,1.4-0.2,2,0.1c0.7,0.3,1.3,1.2,1.9,1.6c0.9,0.6,0.4,0.6,1.2,0.3,c0.9-0.2,0.9-0.7,1.7-0.7c1.4,0,2.8,1.4,3.8-0.5c0.2-0.4-0.1-1.8,0.2-2.1c0.2-0.2,1.6,0,1.9,0c-0.5-0.7-1.3-1.4-0.3-2.1,c0.6,0.7,1.9,3.4,3.3,2.4c0.4-0.3,0.1-1.7,0.5-2.1c0.3-0.3,2.1-0.3,2.6-0.4c3.1-0.4,4.5-3.8,7.9-3.1c-0.6,2.5,0.7,2.7,2.8,3.9,c0.3-2.3,0.8-1.7,2.9-2.3c1.5-0.5,2-1.3,3.1-2.5c0.2,1.1,0.1,2.6,1,3c1.3,0.6,2.8-0.3,3.5-1.4c0.3-0.5,0.6-0.5,0.5-1,c-0.1-0.6-1.2-1.2-1.4-1.8c-0.3-1,0.2-2.6,0.3-3.6c1.1,0.3,2.3,0.8,3.5,0.9c1.2,0.2,1.3,0.1,2.5-0.6c0.1,0.3,0.3,0.7,0.3,1,c0.6-1.3,0.7-1.9,2.2-2.3c1.3-0.3,2.1,0,3.4,0.6c1.3,0.5,1.4,0.9,2.2,2.2c0.9,1.5,1.1,1.4,2.9,1.5c-0.1,0.5-0.3,1-0.4,1.5,c2.2-0.2,4.3-0.5,6.5-0.7c-0.2,1.5-0.7,3.4,1.4,3.3c1.7-0.1,2.8-2.2,4.2-2.9c0.6-0.3,0.4-0.5,1-0.4c0.7,0.1,1.9,1.6,2.5,2,c1.1,0.8,2.3,1.1,2.6,2.3c0.4,1.5,0,2.6,1.6,3.7c1.3,0.8,2.5,0.1,3.9,0.2c1.3,0.2,4,1.9,5.3,1.5c1.9-0.6,0.6-2.5,0.2-3.6,c1.2,0.2,2.4,0.3,3.6,0.5c1.6,0.2,1.5,0.4,2.2-1.1c0.2,0.5,0.4,1.1,0.6,1.6c0.7-0.4,2-1.7,2.8-1.7c0.7,0,2.2,1.2,2.8,1.5,c0.4-1.6,0.9-2.4,2.4-3.2c1.1-0.6,3.8-1.9,4.9-0.8c1.6,1.6,0.4,3.1,3.3,3.6c2.2,0.4,2.2-0.7,2.7-2.6c0.5,0.6,1.2,1.7,1.9,1.9,c1,0.2,1.9-0.8,2.5-1.4c1.3-1.2,0.4-0.9,0.8-2.5c0.2-0.9,0.3-0.7,1.4-1c1.8-0.5,4.4-0.8,6.1-1.8c1.5-0.9,2.9-3,4.2-4.3,c-1.9-1.3-3-2.8-2.9-5.2c0.1-2.1,2.2-3.6,3.6-5.2c0.8-0.8,1.5-2,2.4-2.6c0.7-0.5,1.6-0.6,2.2-1.1C284.4,84.2,285.2,81.7,286,80.1z, M168.6,104.8c-2.1,0.5-4,0.4-5.7-1.3c-1.3-1.3-1.9-3.5-2.7-5.2c-1.5,0.8-2.9,0.8-4.3-0.7c-0.6-0.6-0.7-0.5,0-1.6,c0.6-0.9,0.4-0.6,1.5-1c1.1-0.4,1.3-0.1,1.5-1.6c0.1-1-0.2-1-0.3-1.9c-0.2-1.2,0.5-3,1.5-4c1.2-1.1,2.9-1.5,4.3-1.3,c0.6,0.1,1.8,0.5,2.3,0.4c0.7-0.2,1.1-1.5,1.9-1.8c0.8-0.3,0.7-0.4,1.6,0.5c0.5,0.5,0.9,1,1.2,1.7c0.9,1.8,0.6,2.2-0.8,3.6,c1,0.6,2.8,1.3,3.5,2.2c0.8,1,1,3.1,1.4,4.4c-0.7,0.1-2.8,0.1-2.5,1.4c0.1,0.6,2.3,1.7,2.9,2.1C173.4,102.1,171,103.5,168.6,104.8z',
  },
  {
    code: 'BE-BXL',
    title: 'Brussels',
    url_alias: 'brussels',
    path: 'M175.6,101c-0.5-0.4-2.8-1.5-2.9-2.1c-0.2-1.3,1.8-1.4,2.6-1.5c-0.4-1.2-0.6-3.2-1.4-4.3,c-0.7-1-2.5-1.7-3.5-2.3c1.3-1.3,1.7-1.7,1-3.4c-0.5-1.1-1.6-2.8-2.7-2.5c-0.8,0.2-1.2,1.6-2,1.9c-0.5,0.2-1.6-0.2-2.1-0.3,c-1.6-0.3-3.1,0-4.5,1.2c-0.7,0.6-2,2.7-1.8,3.6c0.1,0.7,0.7,1.1,0.7,1.8c0,1.1-0.4,1.6-1.1,1.9c-0.7,0.4-1.3,0.1-1.8,0.7,c-0.5,0.6-0.8,1.4-0.5,1.9c0.3,0.4,2,1.3,2.5,1.4c0.7,0.1,1.2-0.2,1.9-0.6c1.4,3,2.5,6.8,6.5,6.8C169.7,105.2,173,102.4,175.6,101z',
  },
];

export const COUNTRIES_TRANSLATIONS = {
  belgique: 'BE',
  belgie: 'BE',
  belgium: 'BE',
  'pays-bas': 'NL',
  nederland: 'NL',
  netherlands: 'NL',
  luxembourg: 'LU',
  luxemburg: 'LU',
  frankrijk: 'FR',
  france: 'FR',
};

export const COVERED_COUNTRIES = ['FR', 'NL', 'LU', 'BE'];

export const FRANCE_DEPARTMENTS = [
  {
    code: '01',
    title: 'Ain',
    region: 'FR-ARA',
    url_alias: 'ain',
  },
  {
    code: '03',
    title: 'Allier',
    region: 'FR-ARA',
    url_alias: 'allier',
  },
  {
    code: '07',
    title: 'Ardèche',
    region: 'FR-ARA',
    url_alias: 'ardeche',
  },
  {
    code: '15',
    title: 'Cantal',
    region: 'FR-ARA',
    url_alias: 'cantal',
  },
  {
    code: '26',
    title: 'Drôme',
    region: 'FR-ARA',
    url_alias: 'drome',
  },
  {
    code: '38',
    title: 'Isère',
    region: 'FR-ARA',
    url_alias: 'isere',
  },
  {
    code: '42',
    title: 'Loire',
    region: 'FR-ARA',
    url_alias: 'loire',
  },
  {
    code: '43',
    title: 'Haute-Loire',
    region: 'FR-ARA',
    url_alias: 'haute-loire',
  },
  {
    code: '63',
    title: 'Puy-de-Dôme',
    region: 'FR-ARA',
    url_alias: 'puy-de-dome',
  },
  {
    code: '69',
    title: 'Rhône',
    region: 'FR-ARA',
    url_alias: 'rhone',
  },
  {
    code: '73',
    title: 'Savoie',
    region: 'FR-ARA',
    url_alias: 'savoie',
  },
  {
    code: '74',
    title: 'Haute-Savoie',
    region: 'FR-ARA',
    url_alias: 'haute-savoie',
  },
  {
    code: '21',
    title: "Côte-d'Or",
    region: 'FR-BFC',
    url_alias: 'cote-d-or',
  },
  {
    code: '25',
    title: 'Doubs',
    region: 'FR-BFC',
    url_alias: 'doubs',
  },
  {
    code: '39',
    title: 'Jura',
    region: 'FR-BFC',
    url_alias: 'jura',
  },
  {
    code: '58',
    title: 'Nièvre',
    region: 'FR-BFC',
    url_alias: 'nievre',
  },
  {
    code: '70',
    title: 'Haute-Saône',
    region: 'FR-BFC',
    url_alias: 'haute-saone',
  },
  {
    code: '71',
    title: 'Saône-et-Loire',
    region: 'FR-BFC',
    url_alias: 'saone-et-loire',
  },
  {
    code: '89',
    title: 'Yonne',
    region: 'FR-BFC',
    url_alias: 'yonne',
  },
  {
    code: '90',
    title: 'Territoire de Belfort',
    region: 'FR-BFC',
    url_alias: 'territoire-de-belfort',
  },
  {
    code: '22',
    title: "Côtes-d'Armor",
    region: 'FR-BRE',
    url_alias: 'cotes-d-armor',
  },
  {
    code: '29',
    title: 'Finistère',
    region: 'FR-BRE',
    url_alias: 'finistere',
  },
  {
    code: '35',
    title: 'Ille-et-Vilaine',
    region: 'FR-BRE',
    url_alias: 'ille-et-vilaine',
  },
  {
    code: '56',
    title: 'Morbihan',
    region: 'FR-BRE',
    url_alias: 'morbihan',
  },
  {
    code: '18',
    title: 'Cher',
    region: 'FR-CVL',
    url_alias: 'cher',
  },
  {
    code: '28',
    title: 'Eure-et-Loir',
    region: 'FR-CVL',
    url_alias: 'eure-et-loir',
  },
  {
    code: '36',
    title: 'Indre',
    region: 'FR-CVL',
    url_alias: 'indre',
  },
  {
    code: '37',
    title: 'Indre-et-Loire',
    region: 'FR-CVL',
    url_alias: 'indre-et-loire',
  },
  {
    code: '41',
    title: 'Loir-et-Cher',
    region: 'FR-CVL',
    url_alias: 'loir-et-cher',
  },
  {
    code: '45',
    title: 'Loiret',
    region: 'FR-CVL',
    url_alias: 'loiret',
  },
  {
    code: '20', // 2A but 20 for matching with postal code
    title: 'Corse-du-Sud',
    region: 'FR-COR',
    url_alias: 'corse-du-sud',
  },
  {
    code: '20', // 2B but 20 for matching with postal code
    title: 'Haute-Corse',
    region: 'FR-COR',
    url_alias: 'haute-corse',
  },
  {
    code: '08',
    title: 'Ardennes',
    region: 'FR-GES',
    url_alias: 'ardennes',
  },
  {
    code: '10',
    title: 'Aube',
    region: 'FR-GES',
    url_alias: 'aube',
  },
  {
    code: '51',
    title: 'Marne',
    region: 'FR-GES',
    url_alias: 'marne',
  },
  {
    code: '52',
    title: 'Haute-Marne',
    region: 'FR-GES',
    url_alias: 'haute-marne',
  },
  {
    code: '54',
    title: 'Meurthe-et-Moselle',
    region: 'FR-GES',
    url_alias: 'meurthe-et-moselle',
  },
  {
    code: '55',
    title: 'Meuse',
    region: 'FR-GES',
    url_alias: 'meuse',
  },
  {
    code: '57',
    title: 'Moselle',
    region: 'FR-GES',
    url_alias: 'moselle',
  },
  {
    code: '67',
    title: 'Bas-Rhin',
    region: 'FR-GES',
    url_alias: 'bas-rhin',
  },
  {
    code: '68',
    title: 'Haut-Rhin',
    region: 'FR-GES',
    url_alias: 'haut-rhin',
  },
  {
    code: '88',
    title: 'Vosges',
    region: 'FR-GES',
    url_alias: 'vosges',
  },
  {
    code: '02',
    title: 'Aisne',
    region: 'FR-HDF',
    url_alias: 'aisne',
  },
  {
    code: '59',
    title: 'Nord',
    region: 'FR-HDF',
    url_alias: 'nord',
  },
  {
    code: '60',
    title: 'Oise',
    region: 'FR-HDF',
    url_alias: 'oise',
  },
  {
    code: '62',
    title: 'Pas-de-Calais',
    region: 'FR-HDF',
    url_alias: 'pas-de-calais',
  },
  {
    code: '80',
    title: 'Somme',
    region: 'FR-HDF',
    url_alias: 'somme',
  },
  {
    code: '75',
    title: 'Paris',
    region: 'FR-IDF',
    url_alias: 'paris',
  },
  {
    code: '77',
    title: 'Seine-et-Marne',
    region: 'FR-IDF',
    url_alias: 'seine-et-marne',
  },
  {
    code: '78',
    title: 'Yvelines',
    region: 'FR-IDF',
    url_alias: 'yvelines',
  },
  {
    code: '91',
    title: 'Essonne',
    region: 'FR-IDF',
    url_alias: 'essonne',
  },
  {
    code: '92',
    title: 'Hauts-de-Seine',
    region: 'FR-IDF',
    url_alias: 'hauts-de-seine',
  },
  {
    code: '93',
    title: 'Seine-Saint-Denis',
    region: 'FR-IDF',
    url_alias: 'seine-saint-denis',
  },
  {
    code: '94',
    title: 'Val-de-Marne',
    region: 'FR-IDF',
    url_alias: 'val-de-marne',
  },
  {
    code: '95',
    title: "Val-d'Oise",
    region: 'FR-IDF',
    url_alias: "val-d'oise",
  },
  {
    code: '14',
    title: 'Calvados',
    region: 'FR-NOR',
    url_alias: 'calvados',
  },
  {
    code: '27',
    title: 'Eure',
    region: 'FR-NOR',
    url_alias: 'eure',
  },
  {
    code: '50',
    title: 'Manche',
    region: 'FR-NOR',
    url_alias: 'manche',
  },
  {
    code: '61',
    title: 'Orne',
    region: 'FR-NOR',
    url_alias: 'orne',
  },
  {
    code: '76',
    title: 'Seine-Maritime',
    region: 'FR-NOR',
    url_alias: 'seine-maritime',
  },
  {
    code: '16',
    title: 'Charente',
    region: 'FR-NAQ',
    url_alias: 'charente',
  },
  {
    code: '17',
    title: 'Charente-Maritime',
    region: 'FR-NAQ',
    url_alias: 'charente-maritime',
  },
  {
    code: '19',
    title: 'Corrèze',
    region: 'FR-NAQ',
    url_alias: 'correze',
  },
  {
    code: '23',
    title: 'Creuse',
    region: 'FR-NAQ',
    url_alias: 'creuse',
  },
  {
    code: '24',
    title: 'Dordogne',
    region: 'FR-NAQ',
    url_alias: 'dordogne',
  },
  {
    code: '33',
    title: 'Gironde',
    region: 'FR-NAQ',
    url_alias: 'gironde',
  },
  {
    code: '40',
    title: 'Landes',
    region: 'FR-NAQ',
    url_alias: 'landes',
  },
  {
    code: '47',
    title: 'Lot-et-Garonne',
    region: 'FR-NAQ',
    url_alias: 'lot-et-garonne',
  },
  {
    code: '64',
    title: 'Pyrénées-Atlantiques',
    region: 'FR-NAQ',
    url_alias: 'pyrenees-atlantiques',
  },
  {
    code: '79',
    title: 'Deux-Sèvres',
    region: 'FR-NAQ',
    url_alias: 'deux-sevres',
  },
  {
    code: '86',
    title: 'Vienne',
    region: 'FR-NAQ',
    url_alias: 'vienne',
  },
  {
    code: '87',
    title: 'Haute-Vienne',
    region: 'FR-NAQ',
    url_alias: 'haute-vienne',
  },
  {
    code: '09',
    title: 'Ariège',
    region: 'FR-OCC',
    url_alias: 'ariege',
  },
  {
    code: '11',
    title: 'Aude',
    region: 'FR-OCC',
    url_alias: 'aude',
  },
  {
    code: '12',
    title: 'Aveyron',
    region: 'FR-OCC',
    url_alias: 'aveyron',
  },
  {
    code: '30',
    title: 'Gard',
    region: 'FR-OCC',
    url_alias: 'gard',
  },
  {
    code: '31',
    title: 'Haute-Garonne',
    region: 'FR-OCC',
    url_alias: 'haute-garonne',
  },
  {
    code: '32',
    title: 'Gers',
    region: 'FR-OCC',
    url_alias: 'gers',
  },
  {
    code: '34',
    title: 'Hérault',
    region: 'FR-OCC',
    url_alias: 'herault',
  },
  {
    code: '46',
    title: 'Lot',
    region: 'FR-OCC',
    url_alias: 'lot',
  },
  {
    code: '48',
    title: 'Lozère',
    region: 'FR-OCC',
    url_alias: 'lozere',
  },
  {
    code: '65',
    title: 'Hautes-Pyrénées',
    region: 'FR-OCC',
    url_alias: 'hautes-pyrenees',
  },
  {
    code: '66',
    title: 'Pyrénées-Orientales',
    region: 'FR-OCC',
    url_alias: 'pyrenees-orientales',
  },
  {
    code: '81',
    title: 'Tarn',
    region: 'FR-OCC',
    url_alias: 'tarn',
  },
  {
    code: '82',
    title: 'Tarn-et-Garonne',
    region: 'FR-OCC',
    url_alias: 'tarn-et-garonne',
  },
  {
    code: '44',
    title: 'Loire-Atlantique',
    region: 'FR-PDL',
    url_alias: 'loire-atlantique',
  },
  {
    code: '49',
    title: 'Maine-et-Loire',
    region: 'FR-PDL',
    url_alias: 'maine-et-loire',
  },
  {
    code: '53',
    title: 'Mayenne',
    region: 'FR-PDL',
    url_alias: 'mayenne',
  },
  {
    code: '72',
    title: 'Sarthe',
    region: 'FR-PDL',
    url_alias: 'sarthe',
  },
  {
    code: '85',
    title: 'Vendée',
    region: 'FR-PDL',
    url_alias: 'vendee',
  },
  {
    code: '04',
    title: 'Alpes-de-Haute-Provence',
    region: 'FR-PAC',
    url_alias: 'alpes-de-haute-provence',
  },
  {
    code: '05',
    title: 'Hautes-Alpes',
    region: 'FR-PAC',
    url_alias: 'hautes-alpes',
  },
  {
    code: '06',
    title: 'Alpes-Maritimes',
    region: 'FR-PAC',
    url_alias: 'alpes-maritimes',
  },
  {
    code: '13',
    title: 'Bouches-du-Rhône',
    region: 'FR-PAC',
    url_alias: 'bouches-du-rhone',
  },
  {
    code: '83',
    title: 'Var',
    region: 'FR-PAC',
    url_alias: 'var',
  },
  {
    code: '84',
    title: 'Vaucluse',
    region: 'FR-PAC',
    url_alias: 'vaucluse',
  },
  {
    code: '974',
    title: 'Réunion',
    iso2: 'RE',
    region: 'DROM-COM',
    url_alias: 'reunion',
  },
  {
    code: '972',
    title: 'Martinique',
    iso2: 'MQ',
    region: 'DROM-COM',
    url_alias: 'martinique',
  },
  {
    code: '971',
    title: 'Guadeloupe',
    iso2: 'GP',
    region: 'DROM-COM',
    url_alias: 'guadeloupe',
  },
  {
    code: '976',
    title: 'Mayotte',
    iso2: 'YT',
    region: 'DROM-COM',
    url_alias: 'mayotte',
  },
  {
    code: '987',
    title: 'Polynésite Française',
    iso2: 'PF',
    region: 'DROM-COM',
    url_alias: 'polynesie-francaise',
  },
];

export const FRANCE_OVERSEAS = [
  {
    code: '974',
    title: 'Réunion',
    iso2: 'RE',
    region: 'DROM-COM',
    url_alias: 'reunion',
  },
  {
    code: '972',
    title: 'Martinique',
    iso2: 'MQ',
    region: 'DROM-COM',
    url_alias: 'martinique',
  },
  {
    code: '971',
    title: 'Guadeloupe',
    iso2: 'GP',
    region: 'DROM-COM',
    url_alias: 'guadeloupe',
  },
  {
    code: '976',
    title: 'Mayotte',
    iso2: 'YT',
    region: 'DROM-COM',
    url_alias: 'mayotte',
  },
  {
    code: '987',
    title: 'Polynésite Française',
    iso2: 'PF',
    region: 'DROM-COM',
    url_alias: 'polynesie-francaise',
  },
];

export const FRANCE_REGIONS = [
  {
    code: 'FR-ARA',
    title: 'Auvergne-Rhône-Alpes',
    url_alias: 'auvergne-rhone-alpes',
    path: 'M169.3,254.8l1.8,0.8l7.4,0.7l8.3-11.6l3.7,6.8l2.3-0.2l0.6,5.2l3.5-8.4l6-3.9l4.1,3.2l0.3,3.4l2,0l1.3-3.7l2.5-0.1l0.2,2.9l5.1,2.1l3.3,12.9l2.8,1.9l0.2,3l5,2.4l1.8-3.2l4.3,0.9l-0.3,1.9l8-1l0.1-0.1l0.2,0.1l0,0l0,0l0.5-0.1l-0.1,0.2l4,1.9l8.9-2.6l-3.5,5.6l4.7-1.8l5.8,4.3l2.7-2.6l1.9,0.8l1.4-1.6l-2.3-3.5l-2.9-0.9l-3.1-2.9l2.3-2.7l4.7-0.3l1.2-1.8l-3-1.7l2.3-2.8l3.3-0.1l3.4-5.5l2.7-0.8l2.1-1.5l4.8-0.8l4.3,1.7l0.5-4.3l-4.9-2.2l0.3-4.2l5.1,1.8l6.6-3l-0.3-0.4l8.3-0.7l3.1-2.7l3.2-0.2l0.2-5.6l1.7-2.2l-4.2-2.2l-1-6.2l-5.1-4.1l0.3-4.8l5.6-1.7l0.6-4.5l-5.2-4.1l-2.5-4.5l4.2-1.4l-1.4-4.9l-10.5-0.6l-4.2,3.2l-0.1,4.2l-7.6,3.9l-1.3,0.1l-1.1-3l5.4-4.4l-2.2-6.5l-12.4,8l-3.8-3.1l-3.6,2.3l-5.7-5.4l0,0l0,0l0.3-0.2l2.9-2.6l-1.1-2l-10.6-0.1l-1.3,8.8l-2.6,3.2l-6.2-5.4l-6.7,6.7l-7.3-0.8l-3.1-3.2l2.3-3.6l0.1-6l-5-2.7l-4.6-7.9l-4.8,3.4l-10-2.4l-0.1-3l-13.4,3.4l-1.4,7.4l-8.8,3.4l1.7,4.9l8.1,8l-0.9,7.4l-5.7,2.3l2.7,3l-1.3,2.8l3,3.7L182,220l-0.1,4.7l-0.1,1.7l-6.2,1.6l-1.2,5l-3.1,2.3l-0.8,3.2l-2.7,3.8l-1,5.5l3.6,1.3L169.3,254.8z',
  },
  {
    code: 'FR-BFC',
    title: 'Bourgogne-Franche-Comté',
    url_alias: 'bourgogne-franche-comte',
    path: 'M296.8,128.3l-2.1,3.2l-3.2-4.2l-7,1.8l-0.2-3.3l-7.1,1.8l-5,6.1l0.3,3.1l-2.9,1.7l-1.3-1.5l-3.8,3.4l0,0l0,0l-0.1,0l-7.7-1.4l-3.5-2.4l0-0.1l0,0l0.1-1.2l0.3-3.7l-8-8.9l-3.4,1.5l-6.9,3.4l-2.5,1.4l-2.4-2.7l-7.4,0.7l-4.1-9.9l-4.5-0.6l0-0.1l-0.1,0l0.7-4.3l-3.9-2.2l-8.3,0.2l-5.6,7.3l2.7,0.5l0.2,0l0.5,8.9l-3.4,6.9l2.2,5.2l-3.1,2.2l-0.4,4.7l3,4.1l-0.8,11.4l2.2,4.4l0,0l0,0l0,0.1l-0.1,4.3l0.1,2.9l9.3,2.2l5.1-3.6l4.9,8.4l5.2,2.8l-0.1,6.5l-2.1,3.4l2.6,2.7l6.8,0.8l6.9-6.9l6.2,5.3l2.1-2.5l1.4-9.2l11.5,0.1l0.1,0.1l1.5,2.8l-3.1,2.5l4.9,4.5l3.6-2.3l3.8,3.1l12.1-7.8l0,0l2.3-5.2l-0.5-4.5l0.2-0.9l7-4.1l1.3-5.2l16.5-13.7l0.1-1.9l-7-0.8l3.8-3.2l3.5-0.6l0.4-3.9l0,0l-2.8-2.8l-0.7-3.2l-4.5-2.1l0-0.1L296.8,128.3z',
  },
  {
    code: 'FR-BRE',
    title: 'Bretagne',
    url_alias: 'bretagne',
    path: 'M60.1,131.1l4.1-1.6l2.5-5.8l5.7-0.4l3.1-2l4.7,0.4l4.3-3.8l4.7,3l3.3-4.4l0.6-3l4.5,0.3l0.2-2.6l-2.7-7.3l2.8-2.4l0.7-8.7l-5.8-1L90,95.6l-5-2.8l0-3.7l-5.2,0l-0.8-2.4l0.4-0.7l-2.6,0.2l0.2,2.8l-2.7,0.7l-1.4-1.4l-4.2,1.4l0.3-4.4l-5.1,1l-6.4,3.4l-5.5-8.9l-3.3-2.7l0.6-3.7l-5.9,1.8L38,75.9l-7.8,7.6l-1.8-4l-2.3,3.8l-3.7-3.7l-8.8,1.6l-2-1.9l-9.4,3.1l0.1,3.3L0,86.4l1.4,2.8l6.1,0l5.1-1.5l0.5,0.9l-1.8,1.6l3.9,3.4l-7.3,0.9l-2.3-2.2l-1.7,1l2,1.9l0.6,1.2L8,95l5,5.1l-5,2.3l-6.7-0.1c2.9,1.5,7,4.5,6.8,9.6l5.2,2.3l-0.1-3.7l6.3,0.4l1.3,2.6l8.1,1.6l4.5,4.8l1.8-0.9l4.7,2.6l1,3.6l-1,4.1l0.9,1.1l0-4.5l3.8-1.4l6.8,0l0.3,3.2l-4,0.1l2.7,2.7L60.1,131.1z',
  },
  {
    code: 'FR-CVL',
    title: 'Centre-Val de Loire',
    url_alias: 'centre-val-de-loire',
    path: 'M199.7,169.7l0-1.5l0.1-2.6l-2.2-4.4l0.8-11.4l-3-4.1l0.4-5.2l2.9-2l-2.1-5l3.4-7l-0.5-8.3l-13.4-2.4l-0.2,0l-2.5-6.2l-9.8,0.2l-5.1-7.9l-6-5l0-0.1l-0.1-0.1l-0.1-5.7l-1.2-1.4l-1.4-1.6l-11.1,4.2l-0.4,3.6l0.8,2.6l-0.4,5.4l-4.1,1.5l-0.1,4.4l4.9,5.5l-4.1,0.3l-0.4,7.3l-5.9,3.6l-0.1,5.2l-0.2,0l-11.9,0.8l-1,10.2l0,0.1h0l0,0l-4.4,3l1,4.1l5.6,2.3l0,6.4l6.4-1.5l6.3,8.3l4.2,1l-0.9,6.2l5.2,9.9l6.5,1.3l6-0.6l11.2,0.2l2.8,0.5l8.7-3.3l1.4-7.4L199.7,169.7z',
  },
  {
    code: 'FR-COR',
    title: 'Corse',
    url_alias: 'corse',
    path: 'M337,322.6l-3.4-0.4l0.1,0.2l-1.8,10.3l-2.5-1.2l-3.7,2.3l-5.9,1.5l-4.5,7.6l0,3.5l-2.2,1.7l0.4,4.3l4.1,0.5l-3.5,5l3.5,0.5l-1.9,4.4l5.8,1l-3.5,3.7l2.4,2.4l-0.9,2.3l5.4,0.3l4.4,4.2l3.6-4.1l1.9-13.7l-0.2-3.2l4.5-4.2l0.4-12l-2.5-7.7L337,322.6z',
  },
  {
    code: 'FR-GES',
    title: 'Grand Est',
    url_alias: 'grand-est',
    path: 'M327.2,82.9l-3.1,0.4l0,0l-0.5-4.6l-3.6-0.6l-5.7,2.3l-6.9-4.3l-4.3,2.7l-7.4-10.6l-3.2,0.5l-2.7-2.3l-7.4,2.1l-6.5-4.6l-6.3,1l-3.3-1.2l-10-9.5l-3.9-0.6l-0.1-12.9l-7.6,6.2l-7.2-0.6l0.2,6.6l-4.1,6.6l-1.6,7.6l-0.7,2.5l0,0.2l-11.1,1.9l2.6,7l-3.8-0.5l0.4,9.2l-5.9,1.5l2.2,10.1l-3.1,2.7l-0.6,5l-0.3,2.4l4.2,2.3l0,0.1l0,0l-0.6,4l4.1,0.6l4,9.8l7.2-0.7l2.3,2.6l2.1-1l2.6-1.5l4.3-1.9l3.8-1.9l8.7,9.7l-0.4,3.9l-0.1,0.9l3.1,2.1l7.5,1.3l3.9-3.5l1.4,1.5l2.1-1.2l-0.3-3l3.5-4.3l2.1-2.2l7.8-2l0.2,3.3l6.7-1.7l2.9,3.8l2-3l6.3,5.7l4.7,2.3l0.7,3.3l3.1,3.1l0.2,0l0.8,2.8l2.5,3.3l1.3-1.9l3.3-0.5l4.3-5.7l-2.2-4.7l4.5-9.7l-1.3-2.5l9.6-27.3l5-4l1.6-5.2L327.2,82.9z',
  },
  {
    code: 'FR-HDF',
    title: 'Hauts-de-France',
    url_alias: 'hauts-de-france',
    path: 'M169.7,47.3l1.5,5.8l-2.6,8.3l2,2.4l-2.5,3.7l-0.2,8.2l10-1.3l3.4,2.4l4.7-1.5l4,4.8l14.9,1.1l1.5-3.4l6.7,10.6l5.5-1.4l-0.5-9.4l3.5,0.5l-2.5-6.7l11.5-2l2.3-10l4-6.5l-0.2-6.5l-0.2,0l-1.6-11.9l-11.5-1l-2.4-7.3l-6.1-1.1l-3.6-10.4l-8.3,2.7l-4.9-3.8l-2.1-9.8l-10.5,1.5l-9.4,1.6l-3.8,3.3L169.6,28l-2.4,3.4l-0.3,5.3l-0.2,0.3l-0.3,5.3L169.7,47.3z',
  },
  {
    code: 'FR-IDF',
    title: 'Île-de-France',
    url_alias: 'ile-de-france',
    path: 'M183.8,108.9l2.6,6.3l10.1,1.8l6-7.8l8.4-0.2l0.3-2.3l0.6-5.3l3-2.7l-2.2-10l-6.1-9.7l-1.2,2.7l-15.7-1.2l-3.9-4.6l-4.6,1.5l-3.5-2.4l-10.1,1.3l-5.9,2.9l-1.5,8.3l1.4,1.6l1.4,1.7l0,0l0,0l0,0.1l0.2,5.6l5.9,4.9l4.9,7.7L183.8,108.9z',
  },
  {
    code: 'FR-NOR',
    title: 'Normandie',
    url_alias: 'normandie',
    path: 'M83.9,53.6l5.1,12.9L87.7,84l4.1,4.6l-6.3,0.6l0,3.3l4.1,2.3l2.8-3.7l0.2,0l5.9,1v0l0.4,0.1l0.3,0v0l3.1,0.6l0.1,0l3,3.7l12.8-3.6l0,0l0,0l0.1,0.1l4.2,3.7l0,0l0,0l0.5,4.6l9.9-2.6l2.4,3.2l0,2.9l4.8,1.8l3.6,2.6l0.1-4.4l0.2-0.1l3.9-1.5l0.3-4.9l-0.7-2.4l0-0.1l0.4-4.2l11.5-4.3l1.6-8.6l6-3l0.2-8.6l2.3-3.5l-1.9-2.3l2.7-8.4l-1.5-5.5l-0.1-0.2l-3.3-5l0.2-4.4l-1.9,2.7l-6.1,2.9l-9.9,3.6L140,49l-5.7,3.8l-2,4.3l3.4,0.6l2.3,0.5l6.5,1.4l-0.1,1.1l-4.4-0.2l-4.7,1.1l-4.4,1.2l-5.4,2.2l-21.1-3.9l-3.8,0L97.9,54l2.1-3l0-2.7l-1.6-0.9l-4.3,1.3l-7.2,0L84,46.2l-1.2,0.8l2.7,2.3L83.9,53.6z',
  },
  {
    code: 'FR-NAQ',
    title: 'Nouvelle-Aquitaine',
    url_alias: 'nouvelle-aquitaine',
    path: 'M67.8,310.3l13,5.7l3.2,5.3l9.2,0.5l0.9-7.7l3.3,0.4l-0.3-3.4l7.2-5.9l0.1-4.4l-2.1-1l-0.5-5.9l-8.6,0.4l4.5-3.9l-0.5-9.4l8-3.4l1,2.3l2.2-3.6l5.7,0.4l4.9-2l5.5,2.1l2.2-1.1l0.3-1.6l5.4-0.8l1.6-5.3l-2.5-2.5l0.4-1.9l4.6,0.2l-1-5.2l2.9-2.4l0.1-2l4.8-0.9l-0.1-3.1l5.9-9.2l7,1.3l11.4-0.7l2.6-3.7l0.8-3.2l3.1-2.3l1.3-5.2l6.1-1.6l0.1-1.2l0.2-4.9l1.4-3l-3-3.7l1.3-2.8l-3-3.4l6.2-2.5l0.8-6.7l-7.9-7.9l-1.8-5.2l-2.7-0.5l-11.1-0.2l-6,0.6l-6.9-1.4l-5.4-10.3l0.8-5.9l-3.9-0.9l-6.1-8.2l-6.8,1.6l0-6.8l-5.2-2.2l-4.1,1.8l-14.7-0.6l-3.3,3l-11.4-3.4l5.8,5.3l0.6,4.1l6.9,5.7l-2.5,3.2l0.5,7.8l2.3,2.5l-5.7,2.9l-1.4-2.3l-8.4-0.3l-3.1,4.1l5.6,7.2l-3,0.9l2.1,3.2l-3.5,5.2l-4.3,2.3l-3.8-3.6l-4.8-1.7l0.4,2.1l6.4,4.4l1.3,3l4.8,2.3l4.5,5.1l3.3,6.9l0.6,12.3l-1.1,0.2l-3.4-12.7l-5.8-6.1l-0.4-2.7l-1.4,1.4c1,5.2-3,23.1-4.8,30.5l2.1-1.8l3.6,6l-6.9,0l-0.9,3.3L69.8,275l-4.7,12.2l-4.6,5.8l-4.6,3.1l-4.3,0.7l0.4,1.2l3.2,0.2l1.5,3l3.1-2.1l3,3.6l-2.7,6.4l2.9,1l3.2-3.2L67.8,310.3z',
  },
  {
    code: 'FR-OCC',
    title: 'Occitanie',
    url_alias: 'occitanie',
    path: 'M203.3,311.7c1.3-1,4.7-3.6,6.7-3.6c0,0,0,0,0,0c1.1-1.6,5.7-8.1,13-7.6l0.3,0l1.6,3.3l3.5,0.3l0.3-2.2l0.1-0.8l0.2,0l4.9-0.8l-0.4-3.2l0-0.3l4.9-1.2l0.9-5.6l6.6-4.2l-0.6-3.8l-4.2-6.5l1.8-3.8l-8.5,1l0.3-2.2l-3.2-0.7l-1.9,3.3l-5.9-2.8l-0.2-3.1l-2.7-1.8l-3.3-12.8l-5.2-2.1l-0.2-2.7l-1.5,0.1l-1.3,3.7l-3.1,0l-0.3-3.7l-3.5-2.8l-5.4,3.5l-3.9,9.4l-0.6-0.1l-0.6-5.9l-2.1,0.1l-3.4-6.3l-7.9,11.1l-7.9-0.7l-2.4-1l1.1-5.6l-3.5-1.3l1-5.7l-11.3,0.7l-6.6-1.3l-5.5,8.7l0.1,3.5l-4.8,0.9l-0.1,1.8l-2.8,2.3l1.1,5.7l-4.8-0.2l-0.2,1l2.6,2.5l-1.8,6.1l-5.3,0.8l-0.3,1.4l-2.7,1.3l-5.5-2.1l-4.8,1.9l-5.4-0.4l-2.6,4.3l-1.2-2.8l-7,2.9l0.4,9.2l-3.3,2.9l7.4-0.4l0.5,6.1l2.1,1l-0.2,5.1l-7.1,5.9l0.3,3.8l-3.5-0.5l-0.8,7.3l6.7,4.9l6.1-0.6l2.8,2.4l2.8-1.2l2.8,0.2l5.1,1.4l0.4-6.4l5.7,1l8.7,4.8l4-0.3l2.4,4.6l5.6,0.1l3.4,2.3l-0.9,2.7l3.5,1.2l4.4,6.3l6.7-3.8l3.6,2.5l4.3,3.4l3.8-3.2l3.1,2.3l3.4-3.7l8.2,0.1l2,1.5l1.4-1.8l-2.2-3.1l-2.2-1.5l-0.8-9.8c0-0.5-0.2-11.3,7.3-15.3C196.5,312.9,198.9,311.3,203.3,311.7z',
  },
  {
    code: 'DROM-COM',
    title: 'Outre-mer',
    url_alias: 'outre-mer',
    path: 'none',
  },
  {
    code: 'FR-PDL',
    title: 'Pays de la Loire',
    url_alias: 'pays-de-la-loire',
    path: 'M99.8,154l3.3-2.9l14.8,0.6l3.8-1.7l-1-4.4l4.5-3.1l0.9-10.6l12.2-0.8l0.1-5l0,0v0l0.1-0.1l5.6-3.6l0.4-7.2l0-0.3h0l0,0l3.4-0.2l-4.1-4.6l-4.1-2.9l-5.1-1.9l0-3.2l-2-2.7l-10.2,2.7l0,0h0l0-0.4l-0.6-4.7l-3.9-3.4l-12.8,3.7l-3.1-3.8l-2.9-0.5l-0.7,8.9l-2.6,2.3l2.5,7l-0.2,3.4l-4.6-0.3l-0.6,2.7l-3.7,5l-4.8-3.1l-4.2,3.6l-4.7-0.4l-3,2l-5.5,0.4l-2.4,5.7l-4.1,1.6l-3.9,2.8l0.9,3.2l-1.6,0.6l5.4,1.9l4.1-2.1l10,2.2l-0.1,1.1l-9,0.2l-2.1,3.5l5.1,3.7l-0.9,2.1l-3.8,2.2l0.7,2.6l-2.3,1.1l6,5.8l2.2,8.5c0.7,0,2.2,0.2,2.7,0.3c0.2,0.1,0.6,0.2,7.1,6.8l5.9,1.3l0,0.1l8.3,0.3l1.3,2.1l4.4-2.2l-1.9-2l-0.5-8.3l2.3-2.9l-6.6-5.4l-0.6-4.2l-6.7-6.1l0.3-0.5L99.8,154z',
  },
  {
    code: 'FR-PAC',
    title: "Provence-Alpes-Côte d'Azur",
    url_alias: 'provence-alpes-cote-d-azur',
    path: 'M310.6,302.2l5-6.5l7.4-0.8l2.7-7.9l4.6-3.9l-1.7-4.3l-6.9,1.3l-7.7-2.3l-6.6-3.5l-3.4-2.9l1.8-4l-2.7-2.9l1.9-5l1.7-1.9l2.6-0.7l-0.5-5l-4.3-0.8l-7-10.9l-6.9,3.1l-4.5-1.6l-0.2,2.9l4.9,2.2l-0.6,5.6l-4.9-1.9l-4.4,0.7l-2.1,1.5l-2.5,0.7l-3.5,5.6l-3.3,0.1l-1.6,2l2.9,1.6l-1.7,2.7l-4.8,0.3l-1.7,2l1.4,1.3l1.3,1.2l2.9,0.9l2.7,4.1l-2.1,2.3l-2-0.8l-2.8,2.7l-6-4.5l-6.2,2.3l3.6-5.7l-7.5,2.2l-4.2-2l-1.7,3.7l4.1,6.3l0.7,4.3l-6.7,4.3l-0.9,5.7l-4.7,1.1l0.5,3.6l-5.4,0.8l-0.1,1l-0.2,1.6l6.3,0.5l2.5,3.8l5,1.2l1.3-3.4l4.3,0.2l2.2,3.6l6-1.4l4.3,3.7l-2.8,2.1l2,1.1l8.7,0.5l2.9,4.2l4.1,1.8l-0.5-3.1l7.7,2.2l-0.5-3.4l6.6,1.7l1.4-2.9l5.6,0.6l3.3-3.2l-3.9-0.7l3.9-4.4l4-0.5l3.4-6.2L310.6,302.2z',
  },
];

export const NETHERLANDS_PROVINCES = [
  {
    code: 'GRO',
    title: 'Provincie Groningen',
    region: 'NL',
    url_alias: 'provincie-groningen',
  },
  {
    code: 'FRI',
    title: 'Provincie Friesland',
    region: 'NL',
    url_alias: 'provincie-friesland',
  },
  {
    code: 'DRE',
    title: 'Provincie Drenthe',
    region: 'NL',
    url_alias: 'provincie-drenthe',
  },
  {
    code: 'OVE',
    title: 'Provincie Overijssel',
    region: 'NL',
    url_alias: 'provincie-overijssel',
  },
  {
    code: 'FLE',
    title: 'Provincie Flevoland',
    region: 'NL',
    url_alias: 'provincie-flevoland',
  },
  {
    code: 'GEL',
    title: 'Provincie Gelderland',
    region: 'NL',
    url_alias: 'province-gelderland',
  },
  {
    code: 'UTR',
    title: 'Provincie Utrecht',
    region: 'NL',
    url_alias: 'province-utrecht',
  },
  {
    code: 'NOH',
    title: 'Provincie Noord-Holland',
    region: 'NL',
    url_alias: 'province-noord-holland',
  },
  {
    code: 'ZUI',
    title: 'Provincie Zuid-Holland',
    region: 'NL',
    url_alias: 'province-zuid-holland',
  },
  {
    code: 'ZEE',
    title: 'Provincie Zeeland',
    region: 'NL',
    url_alias: 'province-zeeland',
  },
  {
    code: 'NOB',
    title: 'Provincie Noord-Brabant',
    region: 'NL',
    url_alias: 'province-boord-brabant',
  },
  {
    code: 'LIM',
    title: 'Provincie Limburg',
    region: 'NL',
    url_alias: 'province-limburg',
  },
];

export const OTHER_COUNTRIES = ['DE', 'CH', 'ES', 'PT', 'IT', 'AD'];
